// extracted by mini-css-extract-plugin
export default {"container":"BubbleCart_container__l8qSx","opacidad":"BubbleCart_opacidad__0sGHQ","img":"BubbleCart_img__PwGuN","amount":"BubbleCart_amount__3dQR-"};